/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_SendingInputs */

const en_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

const fr_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi`)
};

const de_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const it_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio`)
};

const ru_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка`)
};

const es_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envío`)
};

const zh_cn2_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送`)
};

const ja_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信中`)
};

const hi_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भेजना`)
};

const pt_pt2_live_caption_status_sending = /** @type {(inputs: Live_Caption_Status_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Live_Caption_Status_SendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_sending = /** @type {((inputs?: Live_Caption_Status_SendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_SendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_status_sending(inputs)
	if (locale === "de") return de_live_caption_status_sending(inputs)
	if (locale === "it") return it_live_caption_status_sending(inputs)
	if (locale === "ru") return ru_live_caption_status_sending(inputs)
	if (locale === "es") return es_live_caption_status_sending(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_status_sending(inputs)
	if (locale === "ja") return ja_live_caption_status_sending(inputs)
	if (locale === "hi") return hi_live_caption_status_sending(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_status_sending(inputs)
	return en_live_caption_status_sending(inputs)
});